export default __webpack_public_path__ + "static/media/Från A till B_mixare.7ecfa954.png";